import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Global ScrollToTop component
 * Ensures that every route change scrolls the view to the top.
 * Handles both standard window scroll and internal dashboard container scroll.
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const scrollToTop = () => {
      // 1. Reset global window scroll
      window.scrollTo(0, 0);

      // 2. Reset all internal scrollable containers
      // This targets the Dashboard <main> and any other containers using 'overflow-y-auto'
      const scrollableElements = document.querySelectorAll('.overflow-y-auto, main, [style*="overflow-y: auto"], [style*="overflow-y: scroll"]');
      scrollableElements.forEach((el) => {
        el.scrollTop = 0;
      });
    };

    // Execute immediately on route change
    scrollToTop();

    // Use a small timeout to override browser's native scroll restoration on back/forward navigation
    const timeoutId = setTimeout(scrollToTop, 0);

    // Also use requestAnimationFrame to catch the next paint
    const rafId = requestAnimationFrame(scrollToTop);

    return () => {
      clearTimeout(timeoutId);
      cancelAnimationFrame(rafId);
    };
  }, [pathname]);

  return null;
};

export default ScrollToTop;
